export interface SearchResult {
    themeId: string;
    themeName: string;
    subjectName: string;
}

export interface SearchResultItem extends SearchResult {
    subject: string;
    number: number;
}

export interface SubjectResult {
    subjectName: string;
    results: Array<SearchResult>;
}

export type SearchResults = Record<string, SubjectResult>;

export enum LIBRARY_SEARCH_STATE {
    EMPTY = 'empty',
    LOADING = 'loading',
    LOADED = 'loaded',
    NOT_FOUND = 'not_found',
}

export interface SearchFilters {
    subjects: string[];
}
